import LogoutOutlined from '@mui/icons-material/LogoutOutlined'
import ManageAccountsOutlined from '@mui/icons-material/ManageAccountsOutlined'
import {Avatar, Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem} from '@mui/material'
import {bindMenu} from 'material-ui-popup-state'
import {bindTrigger, usePopupState} from 'material-ui-popup-state/hooks'
import {memo} from 'react'
import {useTranslation} from 'react-i18next'
import {Link as RouterLink} from 'react-router'
import {CircularSkeleton} from '../../../../components/Skeleton/CircularSkeleton'
import {useUserHelperGetCurrent} from '../../../../hooks/entity/useUser'
import {useLogout} from '../../../../hooks/useAuth'
import {useEffectEvent} from '../../../../hooks/useEffectEvent'
import {useSpotUrl} from '../../../../hooks/useSpotNavigate'
import {InstallPwaMenu} from '../../../UserProfile/components/UserSettings/InstallPwaMenu'
import SpeedOutlined from '@mui/icons-material/SpeedOutlined'

const avatarSize = 40

const UserAvatar = memo(() => {
  const {user, error} = useUserHelperGetCurrent()

  if (!user) {
    return <CircularSkeleton height={avatarSize} width={avatarSize} error={error}/>
  }

  return <Avatar alt={user.name} src={user.avatar} sx={{width: avatarSize, height: avatarSize}}/>
})

export const UserSelectorSettings = memo(() => {
  const logout = useLogout()
  const {t} = useTranslation()
  const settingsUrl = useSpotUrl('/profile/me/settings', true)
  const statsUrl = useSpotUrl('/profile/me/stats', true)
  const popupState = usePopupState({variant: 'popper'})

  const handleLogout = useEffectEvent(() => {
    logout()
    popupState.close()
  })

  return <>
    <IconButton sx={{p: 0}} {...bindTrigger(popupState)}>
      <UserAvatar/>
    </IconButton>
    <Menu
      {...bindMenu(popupState)}
      sx={{mt: 1}}
      anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
      transformOrigin={{vertical: 'top', horizontal: 'right'}}
    >
      <MenuItem component={RouterLink} to={settingsUrl} onClick={popupState.close}>
        <ListItemIcon><ManageAccountsOutlined/></ListItemIcon>
        <ListItemText primary={t('page.authentication.settings.profile')}/>
      </MenuItem>
      <MenuItem component={RouterLink} to={statsUrl} onClick={popupState.close}>
        <ListItemIcon><SpeedOutlined/></ListItemIcon>
        <ListItemText primary={t('page.authentication.settings.stats')}/>
      </MenuItem>
      <InstallPwaMenu/>
      <Divider/>
      <MenuItem onClick={handleLogout}>
        <ListItemIcon><LogoutOutlined/></ListItemIcon>
        <ListItemText primary={t('page.authentication.settings.logout')}/>
      </MenuItem>
    </Menu>
  </>
})
